export const ACCOUNT_PLANS = {
  PRO: 'pro',
  RETAIL: 'retail',
};
